<!--
  ContactLines: contact lines of a ProfileField (icon, value, note) with the quick actions call / WhatsApp / mail / website
  and copy. Props: lines (ContactLine[]), emptyText. Slot `line-actions` ({ line }) adds actions per line (e.g. edit).
-->
<template>
  <div>
    <div v-if="!lines.length" class="fld__value fld__value--muted">{{ emptyText }}</div>
    <div v-for="(line, i) in lines" :key="`${line.label}-${i}`" class="fld__line">
      <v-icon :title="line.label" class="cl-icon" color="grey" small>{{ line.icon }}</v-icon>
      <div class="flex-grow-1" style="min-width: 0">
        <div class="fld__value text-truncate">{{ line.display || line.value }}</div>
        <div v-if="line.note" class="fld__note">{{ line.note }}</div>
      </div>
      <a v-if="line.actions.includes('call')" :href="`tel:${line.value}`" class="ibtn" v-tip="'Anrufen'" aria-label="Anrufen"><v-icon>mdi-phone-outgoing-outline</v-icon></a>
      <a v-if="line.actions.includes('whatsapp')" :href="getWhatsAppLink(line.value)" class="ibtn" rel="noopener" target="_blank" v-tip="'Per WhatsApp kontaktieren'" aria-label="Per WhatsApp kontaktieren"><v-icon>mdi-whatsapp</v-icon></a>
      <a v-if="line.actions.includes('mail')" :href="`mailto:${line.value}`" class="ibtn" v-tip="'E-Mail schreiben'" aria-label="E-Mail schreiben"><v-icon>mdi-email-send-outline</v-icon></a>
      <a v-if="line.actions.includes('visit')" :href="websiteHref(line.value)" class="ibtn" rel="noopener" target="_blank" v-tip="'Website öffnen'" aria-label="Website öffnen"><v-icon>mdi-open-in-new</v-icon></a>
      <button class="ibtn" v-tip="'Kopieren'" aria-label="Kopieren" type="button" @click="copy(line)"><v-icon>mdi-content-copy</v-icon></button>
      <slot :line="line" name="line-actions"/>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {getWhatsAppLink} from '@/helpers/getWhatsAppLink';
import {ContactLine, copyWithSnackbar, websiteHref} from './profileUi.helper';

export default Vue.extend({
  props: {
    lines: {type: Array as () => ContactLine[], required: true},
    emptyText: {type: String, default: 'Keine Kontaktdaten hinterlegt'},
  },
  methods: {
    getWhatsAppLink,
    websiteHref,
    copy(line: ContactLine) {
      return copyWithSnackbar(this, line.value, line.label);
    },
  },
});
</script>

<style scoped>
.cl-icon {
  flex: none;
}
</style>
<style src="@/components/acquisitionList/ui/itemDetails.css"></style>
